const subCats = {
  wrap: document.getElementById("paginateCats"),
  show: 8,
  init() {
    this.setSubCats();
  },
  setSubCats() {
    if (this.wrap) {
      const children = [...this.wrap.children];
      if (children.length >= this.show) {
        children.forEach((item, index) => {
          if (index >= this.show ) {
            item.classList.add("d-none");
          }
        });
        this.addPagination(children.length);
      }
    }
  },

  addPagination(count: number) {
    const button = document.createElement("div");
    button.innerHTML = `<div class="show__wrap" >
                                Show All
                                Categories
                        <span class="show__wrap-count" >(${count - this.show })</span>
                    </div>
                  `;

    if(count > 8) {
      button.innerHTML = `<div class="show__wrap" >
      Show All
      Categories
<span class="show__wrap-count" >(+${count - this.show })</span>
</div>
`; 
    } else {
      button.innerHTML = ``;
    }

    this.wrap?.appendChild(button);
    button.addEventListener("click", () => {
      if (this.wrap) {
        const children = [...this.wrap.children];
        children.forEach((item) => item.classList.remove("d-none"));
        button.classList.add("d-none");

      }
    });
  },
};

export default subCats;